import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { CheckIcon } from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom';

const tiers = [
  {
    name: 'Snappy',
    id: 'tier-hobby',
    href: '/Slideshow',
    price: 'FREE',
    description: "Perfect for small slideshows and just getting started.",
    features: [
      'Up to 50 images per folder', 
      '6 second transition'
    ],
    featured: false,
  },
  {
    name: 'Snappy Plus',
    id: 'tier-enterprise',
    href: '/Slideshow',
    price: 'FREE*',
    description: 'Scale up your slideshows with more features.',
    features: [
      'Free with account',
      'Up to 1000 images per folder',
      'Customisable transition',
      'Snappy Plus backgrounds'
    ],
    featured: true,
  },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const Pricing = () => {
  const { user } = useAuth();



  return (
    <div className="relative isolate bg-white min-h-[calc(100vh-4rem)]">
      <div className="absolute inset-0 bg-grid-gray-900/[0.04] bg-[length:20px_20px]" />
      <div className="relative px-6 py-24 sm:py-32 lg:px-8">
        <div aria-hidden="true" className="absolute inset-x-0 -top-3 -z-10 transform-gpu overflow-hidden px-36 blur-3xl">
          <div
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
            className="mx-auto aspect-1155/678 w-[72.1875rem] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-10"
          />
        </div>
        <div className="mx-auto max-w-4xl text-center">
          <p className="mt-2 text-5xl font-semibold tracking-tight text-balance text-primary sm:text-6xl">
            Plans
          </p>
        </div>
        <p className="mx-auto mt-6 max-w-2xl text-center text-lg leading-8 text-gray-600">
          {user ? 'You have access to all Snappy Plus features!' : 'Try our Snappy plan now or create an account to unlock Snappy Plus features.'}
        </p>
        <div className="mx-auto mt-16 grid max-w-lg grid-cols-1 items-center gap-y-6 sm:mt-20 sm:gap-y-0 lg:max-w-4xl lg:grid-cols-2">
          {tiers.map((tier, tierIdx) => (
            <div
              key={tier.id}
              className={classNames(
                tier.featured ? 'relative bg-[#F8AD9D] shadow-2xl' : 
                'bg-white sm:mx-8 lg:mx-0',
                tier.featured
                  ? ''
                  : tierIdx === tiers.length - 1
                    ? 'rounded-3xl'
                    : '',
                'p-8 ring-1 ring-gray-200 sm:p-10',
              )}
            >
              <h3
                id={tier.id}
                className={classNames(
                  tier.featured ? 'text-white' : 'text-primary',
                  'text-base font-semibold leading-7'
                )}
              >
                {tier.name}
              </h3>
              <p className="mt-4 flex items-baseline gap-x-2">
                <span
                  className={classNames(
                    tier.featured ? 'text-white' : 'text-gray-900',
                    'text-5xl font-semibold tracking-tight',
                  )}
                >
                  {tier.price}
                </span>
              </p>
              <p className={classNames(
                tier.featured ? 'text-white/90' : 'text-gray-600',
                'mt-6 text-base leading-7'
              )}>
                {tier.description}
              </p>
              <ul
                className={classNames(
                  tier.featured ? 'text-white/90' : 'text-gray-600',
                  'mt-8 space-y-3 text-sm leading-6 sm:mt-10',
                )}
              >
                {tier.features.map((feature) => (
                  <li key={feature} className="flex gap-x-3">
                    <CheckIcon
                      aria-hidden="true"
                      className={classNames(
                        tier.featured ? 'text-white' : 'text-primary',
                        'h-6 w-5 flex-none'
                      )}
                    />
                    {feature}
                  </li>
                ))}
              </ul>
              {tier.featured ? (
                user ? (
                  <Link
                    to="/slideshow"
                    className={classNames(
                      'bg-white text-[#F8AD9D] hover:bg-gray-50 focus-visible:outline-white',
                      'mt-8 block rounded-md px-3.5 py-2.5 text-center text-sm font-semibold leading-6 focus-visible:outline-2 focus-visible:outline-offset-2 sm:mt-10',
                      'w-full'
                    )}
                  >
                    Create Slideshow
                  </Link>
                ) : (
                  <Link
                    to="/register"
                    className={classNames(
                      'bg-white text-[#F8AD9D] hover:bg-gray-50 focus-visible:outline-white',
                      'mt-8 block rounded-md px-3.5 py-2.5 text-center text-sm font-semibold leading-6 focus-visible:outline-2 focus-visible:outline-offset-2 sm:mt-10',
                      'w-full'
                    )}
                  >
                    Create Account
                  </Link>
                )
              ) : (
                <Link
                  to="/slideshow"
                  className={classNames(
                    'bg-white text-[#F08080] border-2 border-[#F08080] hover:bg-[#FBC4AB] hover:border-[#F8AD9D] hover:text-white focus-visible:outline-[#F08080]',
                    'mt-8 block rounded-md px-3.5 py-2.5 text-center text-sm font-semibold leading-6 focus-visible:outline-2 focus-visible:outline-offset-2 sm:mt-10',
                    'w-full'
                  )}
                >
                  Create Slideshow
                </Link>
              )}
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Pricing; 